import define1 from "./e93997d5089d7165@2303.js";
import define2 from "./a33468b95d0b15b0@808.js";
import define3 from "./266e717755b1d175@112.js";
import define4 from "./f45aab9de8312df2@403.js";
import define5 from "./20f78e399de08ef0@857.js";
import define6 from "./a6645431739ba032@4331.js";
import define7 from "./9ac406907b45efa2@248.js";

function _1(md){return(
md`# aBSREL analysis result visualization`
)}

function _results_file(params,localFileInput){return(
params.get ("url") ? localFileInput({accept: [".json",".gz"], value : params.get ("url"), disable: true}) : localFileInput({accept: [".json",".gz"]})
)}

function _intro(md,results_json,floatFormat,srv_rate_classes,_,mh_rates){return(
md`<span style = 'font-size: 1.1em; color: firebrick;'>Based on the likelihood ratio test, there **are ${results_json["test results"]["positive test results"]}** branches with evidence of _episodic diversifying selection_ in this dataset (<tt>p&leq;${floatFormat(results_json["test results"]["P-value threshold"] || 0.05)}</tt>).</span> <span style = 'font-size: 0.8em'><br>aBSREL analysis (<samp>${results_json.analysis.version}</samp>) was performed on the alignment from <samp>${results_json.input["file name"]}</samp> using HyPhy v<tt>${results_json.runtime}</tt>. <br>This analysis ** ${srv_rate_classes > 0 ? "included" : "did not include"}** site-to-site synonymous rate variation. ${_.size (mh_rates['DH']) == 0 ? "" : (_.size (mh_rates['TH'] == 0) ? "Double nucleotide substitutions were included in the model." : "Double and triple nucleotide substitutions were included in the model.")}${+results_json.analysis.version < 2.5 ? "<p><small><span class = 'stati bg-pumpkin'>Some of the visualizations are not available for BUSTED analyses before v2.5</span></small>" : ""} </span>
`
)}

function _citation(md,results_json){return(
md`<details><summary><small>**Suggested citation**</summary><tt><small>${results_json.analysis["citation"]}</small></tt></small></details>`
)}

function _pv(Inputs,html){return(
Inputs.text({label: html`<b>Evidence ratio threshold</b>`, value: "100", submit: "Update"})
)}

function _summary_table(html,results_json,tested_branch_count,d3,omega_rate_classes,srv_rate_classes,floatFmt,_,distributionTable,pv,mh_rates){return(
html`<table style = 'font-size: 11px; width: 100;'>
<tr>
<td style = 'width: 33%;'>
  <div class="stati asbestos left ">
      <i class="icon-options-vertical icons"></i>
      <div>
      <b>${results_json.input["number of sequences"]}</b>
      <span>sequences in the alignment</span>
      </div> 
  </div>
</td>
<td>
  <div class="stati asbestos left ">
  <i class="icon-options icons"></i>
  <div>
  <b>${results_json.input["number of sites"]}</b>
  <span>codon sites in the alignment</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati asbestos left ">
  <i class="icon-arrow-up icons"></i>
  <div>
  <b>${results_json.input["partition count"]}</b>
  <span>partitions</span>
  </div> 
  </div>
</td>
</tr>
<tr>
<td>
  <div class="stati midnight_blue left ">
  <i class="icon-share icons"></i>
  <div>
  <b>${tested_branch_count}</b>
  <span>median branches/partition used for testing</span>
  </div> 
  </div>
</td>
<td style = 'width: 33%;'>
  <div class="stati midnight_blue left ">
  <i class="icon-grid icons"></i>
  <div>
  <b>${d3.extent (omega_rate_classes).join ("-")} </b>
  <span>&omega; rate classes per branch</span>
  </div> 
  </div>
</td>
<td style = 'width: 33%;'>
  <div class="stati midnight_blue left ">
  <i class="icon-layers icons"></i>
  <div>
  <b>${srv_rate_classes ? "" + srv_rate_classes + " classes" : "None"} </b>
  <span>synonymous rate variation</span>
  </div> 
  </div>
</td>
</tr>
<tr>
<td style = 'width: 33%;'>
  <div class="stati amethyst left ">
  <i class="icon-plus icons"></i>
  <div>
  <b>${results_json["test results"]["positive test results"]}</b>
  <span>branches with evidence of selection</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati  amethyst left ">
  <i class="icon-energy icons"></i>
  <div>  
  <b>${floatFmt(d3.mean (_.map (_.filter (distributionTable, (r)=>r.tested == "Yes"), (d)=>d.sites))||0)}</b>
  <span>Sites/tested branch with ER≥${pv} for positive selection</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati  amethyst left ">
  <i class="icon-target icons"></i>
  <div>
  <b>${_.size(mh_rates['DH']) ? floatFmt (d3.median (_.map (mh_rates['DH']))) : "N/A"}:${_.size(mh_rates['TH']) ?floatFmt (d3.median (_.map (mh_rates['TH']))) : "N/A"} 
  </b>
  <span>Median multiple hit rates (2H:3H)</span>
  </div> 
  </div>
</td>
</tr>
</tr>
</table>
`
)}

function _alignmentHeader(md){return(
md`#### Branch-by-branch results`
)}

function _rate_table(Inputs,distributionTable,html,_,results_json,d3,floatFormat,proportionFormat,distMean,distVar,renderDiscreteDistribution){return(
Inputs.table (distributionTable, {
  header : {'LogL' : "Log (L)", "AICc" : "AIC-c", "p" : html`<abbr title="Number of estimated parameters">Params.</abbr`, "dist" : "ω distribution", "plot" : "ω plot"},
  format : {
    'branch' : (d)=>!_.isUndefined (results_json["branch attributes"][0][d]["Corrected P-value"]) && results_json["branch attributes"][0][d]["Corrected P-value"]<=0.05 ? html`<b>${d}</b>` : d,
    'LogL' : d3.format ("2g"),
    'AICc' : d3.format ("2g"),
    'dist' : (d)=>{
        return html`<tt>
            ${_.map (d[1], (c,i)=> floatFormat(c.value) + " (" + proportionFormat (c.weight) + ") ")}
            <br>Mean = <b>${floatFormat (distMean (d[1]))}</b>, CoV = <b>${floatFormat (Math.sqrt (distVar (d[1]))/distMean (d[1]))}</b></tt>`},
     'plot' : (d)=>d[1].length > 1 ? renderDiscreteDistribution (d[1],{"height" : 40, "width" : 150, "ticks" : 2, "scale" : "log", "ref" : [1]}) : ''
  },
  layout: "auto",
  sort: "p-value",
  height: 300
})
)}

function _distComparisonPlot(rate_table,renderTwoDiscreteDistributions,md){return(
rate_table.length == 2 ? renderTwoDiscreteDistributions (rate_table[0].dist[1],rate_table[1].dist[1],{"label" : {"chart" : rate_table[0].plot[0], "series" : [rate_table[0].dist[3],rate_table[1].dist[3]]}, "width" : 700, "height" : 120, "scale" : "sqrt", "margin" : {top: 5, right: 250, bottom: 30, left: 20}}) : md`<small>Select exactly two distributions to plot a side-by-side comparison</small>`
)}

function _tree_id(autoSelect,treeViewOptions,html){return(
autoSelect ({options:treeViewOptions, size : 10, title: html`<b>Tree to view</b>`, placeholder : "Select something to view", "value" : "Alignment-wide tree"})
)}

function _branch_length(Inputs,_,results_json,html){return(
Inputs.select(_.chain (results_json["branch attributes"]["attributes"]).toPairs().filter (d=>d[1]["attribute type"] == "branch length").map (d=>d[0]).value(),{value: "Baseline MG94xREV", label: html`<b>Branch length </b>`})
)}

function _treeLabels(Inputs,html){return(
Inputs.checkbox(
   ["amino-acids","codons","show internal","show only multiple hits","show only non-synonymous changes","sequence names","align tips","include neighboring codons","show branch labels"],{"value" : ["amino-acids","align tips"], label: html`<b>Tree labels</b>` }
)
)}

function _color_branches(Inputs,tree_color_options,html){return(
Inputs.select(tree_color_options,{value: "Support for selection", label: html`<b>Color branches </b>`})
)}

function _treeDim(Inputs){return(
Inputs.text({placeholder : "1024 x 800", label: "H x W (pixels)", submit: "Resize"})
)}

function _15(tree_id,figure2,Legend,html)
{
  tree_id;
  if (figure2 && figure2.color_scale) {
      return Legend(figure2.color_scale, {
      title: figure2.color_scale_title,
      tickFormat: "f",
      marginLeft: "10",
      marginRight: "10"
    });
  }
  return html``;
}


function _16(figure2,md)
{
  if (figure2) {
      return figure2.show();
  }
  return md`### Select a tree option from the menu above to view`;
}


function _fig1caption(md,plot_type,plot_legends){return(
md`**Figure 1**. ${plot_type ? plot_legends[plot_type] : "No plotting options available"}`
)}

function _plot_type(Inputs,_,plot_options,results_json,html){return(
Inputs.select(_.map (_.filter (plot_options, (d)=>d[1](results_json)), d=>d[0]),{label: html`<b>Plot type</b>`, value : 'Evidence ratio alignment profile'})
)}

function _fig1_controls(plot_extras,plot_type,Inputs){return(
plot_extras[plot_type] || Inputs.text({label: "Plot options", value: "None", disabled: true})
)}

function _figure1(plot_type,vegalite,plot_specs,md){return(
plot_type ? vegalite (plot_specs[plot_type]) : md``
)}

function _table1caption(md){return(
md`**Table 2**. Detailed site-by-site results from the aBSREL analysis`
)}

function _table1(Inputs,sites_table){return(
Inputs.table (sites_table[1], {
  rows : 10,
  format: sites_table[0],
  layout: "auto",
  header: sites_table[2]
})
)}

function _table3caption(md){return(
md`**Table 3**. Detailed site-by-site results for a specific branch in the aBSREL analysis`
)}

function _which_branch(multiAutoSelect,_,profilable_branches){return(
multiAutoSelect({
  options: _.map ([...profilable_branches], (d)=>d),
  placeholder: "Select some branches"
})
)}

function _table3(Inputs,table3_data){return(
Inputs.table (table3_data,
  {
      rows : 10,
      layout: "auto",
      columns : ["branch", "site",  "from", "to", "subs", "ER", "EBF"],
      header: {
          "branch" : "Branch",
          "site" : "Site",
          "ER": "Evidence ratio",
          "from" : "Parent",
          "to" : "Codon",
          "subs" : "# substitutions",
          "EBF" : "Empirical BF",
      }
})
)}

function _26(html,resolve){return(
html`
      <link rel=stylesheet href='${resolve("phylotree@0.1/phylotree.css")}'>
      <div id="tree_container"></div>`
)}

function _27(md){return(
md`#### Code, data, and libraries`
)}

function _figure2(tree_id,treeLabels,siteIndexPartitionCodon,display_tree_site,tree_objects,display_tree)
{
    let toDisplay = tree_id.split (" ");
    if (toDisplay.length > 1) {
      let tree_options = {  
          'branch-labels' : treeLabels.indexOf ("show branch labels") >= 0,
          'neighbors' : treeLabels.indexOf ("include neighboring codons") >= 0
      };
      
      if (toDisplay[0] == "Codon") {  
          const codon_index = (+toDisplay[1]);
          let partition_id = siteIndexPartitionCodon [codon_index-1][0]-1;
          let TT = display_tree_site (partition_id, tree_objects[0], codon_index, tree_options);
          return TT;
      } 
      let TT = display_tree(0, tree_objects[0], tree_options);
      return TT;
    }
    return null;
}


function _floatFormat(d3){return(
d3.format (".4g")
)}

function _percentageFormat(d3){return(
d3.format (".2p")
)}

function _proportionFormat(d3){return(
d3.format (".5p")
)}

async function _results_json(get_json,params){return(
await get_json (params.get ("url"))
)}

function _get_json(pako,d3,results_file){return(
async (json_source)=>  {
  if (json_source) {
      if (json_source.substr (json_source.length-3) == ".gz") {
        return JSON.parse (pako.inflate(await d3.buffer(json_source), { to: 'string' }));
      }
      return d3.json (json_source);
      try {
        return d3.json (json_source);
      } catch {}
      //results_file.json();
  }
  try {
    return JSON.parse (pako.inflate(await results_file.arrayBuffer(), { to: 'string' }));//results_file.json();
  } catch {}
  return results_file.json();
}
)}

function _fig1data(_,table1,siteTableData)
{
   let in_set = new Set (_.map (table1, (d)=>d.Codon));
   return _.filter (siteTableData[0], (x)=>in_set.has (x.Codon));
}


function _plot_legends(){return(
{
  "Synonymous rates" : "Posterior means for synonymous site-level substitution rates (α). ",
  "Support for positive selection" : "Empirical Bayes Factors for ω>1 at a particular branch and site (only tested branches with 2 or more rate classes are included).",
  "Evidence ratio alignment profile" : "Evidence ratios for for ω>1 at a particular branch and site (only tested branches with an ω>1 distribution component are included). Mouse over for more information"
}
)}

function _plot_extras(Inputs){return(
{
    'Evidence ratio alignment profile' : Inputs.select(['Total subs', 'Syn subs', 'Non-syn subs'], {'label' : 'Circle size'} ),
    'Support for positive selection' : Inputs.select(['Total subs', 'Syn subs', 'Non-syn subs'], {'label' : 'Circle size'} )
}
)}

function _plot_options(srv_rate_classes,srv_distribution,bsPositiveSelection,profileBranchSites){return(
[
  ["Synonymous rates", (d)=>srv_rate_classes > 0 && srv_distribution], 
  ["Support for positive selection", (d)=>bsPositiveSelection.length > 0],
  ["Evidence ratio alignment profile", (d)=>profileBranchSites.length > 0]
]
)}

function _plot_specs(_,fig1data,SRVPlot,results_json,er_step_size,BSPosteriorPlot,bsPositiveSelection,ERPosteriorPlot,profileBranchSites){return(
{ "Synonymous rates" : {
  "width": 800, "height": 150, 
  "vconcat" : _.map (_.range (1, fig1data.length + 1, 70), (d)=> {
      return SRVPlot (fig1data, d, 70, "SRV posterior mean", null)
  })},
  "Support for positive selection" : {
    //"autosize": {"resize" : true},
    "vconcat" : _.map (_.range (1, results_json.input["number of sites"], er_step_size()), (d)=> {
        return BSPosteriorPlot (bsPositiveSelection, d, er_step_size())
    })},
   "Evidence ratio alignment profile" : {
    //"autosize": {"resize" : true},
    "vconcat" : _.map (_.range (1, results_json.input["number of sites"], er_step_size()), (d)=> {
        return ERPosteriorPlot (profileBranchSites, d, er_step_size())
    })}
}
)}

function _profilable_branches(_,results_json){return(
new Set (_.chain (_.get (results_json, ["Site Log Likelihood","tested"])).keys().value())
)}

function _tested_branch_count(d3,_,results_json){return(
d3.median (_.chain (results_json.tested).map ().map((d)=>_.filter (_.map (d), (d)=>d=="test").length).value())
)}

function _srv_rate_classes(results_json){return(
results_json["Synonymous site-posteriors"] ? results_json["Synonymous site-posteriors"].length: 0
)}

function _srv_distribution(getRateDistribution){return(
getRateDistribution (["fits","Full adaptive model","Rate Distributions","Synonymous site-to-site rates"], ["rate","proportion"])
)}

function _omega_rate_classes(_,results_json){return(
_.map (results_json["branch attributes"]["0"], (d)=>d["Rate classes"])
)}

function _mh_rates(_,results_json){return(
{
    'DH' : _.chain(_.map (results_json["branch attributes"][0], (d,k) => [k,_.get (d, ['rate at which 2 nucleotides are changed instantly within a single codon'])])).filter (d=>!_.isUndefined(d[1])).fromPairs().value(),
    'TH' : _.chain(_.map (results_json["branch attributes"][0], (d,k) => [k,_.get (d, ['rate at which 3 nucleotides are changed instantly within a single codon'])])).filter (d=>!_.isUndefined(d[1])).fromPairs().value()
}
)}

function _test_omega(getRateDistribution){return(
(branch)=> getRateDistribution (["branch attributes","0",branch,"Rate Distributions"],["0","1"])
)}

function _test_pv(_,results_json){return(
(branch)=> _.get (results_json,["branch attributes","0",branch,"Corrected P-value"])
)}

function _distributionTable(posteriorsPerBranchSite,pv,_,results_json,test_omega)
{
  let table = [];

  let site_er = posteriorsPerBranchSite (true, pv);
  
  _.each (results_json["branch attributes"][0], (info, b)=> {
    let row = {'branch' : b};
    const is_tested = results_json["tested"][0][b] == "test";
    if (is_tested) {
        row['tested'] = 'Yes';
        row['p-value'] = info["Corrected P-value"];
        row['sites'] = site_er[b] || 0;
        
    } else {
        row['tested'] = 'No';
        row['p-value'] = null;
        row['sites'] = null;
    }
    row['rates'] = info['Rate classes'];
    row ['dist'] = ["&omega;",test_omega(b),""];
    row['plot'] = ["",row['dist'][1]];
    table.push (row);
  });
  
  
  /*_.each (["Unconstrained model", "Constrained model"], (m)=> {
      if (!_.get (results_json,["fits",m])) return;
      let record = {'Model' : m};
      record['LogL'] = _.get (results_json,["fits",m,"Log Likelihood"]);
      record['AICc'] = _.get (results_json,["fits",m,"AIC-c"]);
      record['p'] = _.get (results_json,["fits",m,"estimated parameters"]);
      record['dist'] = ["Tested", getRateDistribution (["fits",m,"Rate Distributions","Test"]),"&omega;",m + " ω tested"];
      record['plot'] = ["ω",record['dist'][1]];
      table.push (record);
      if (has_background) {
          record = {'Model' : m};
          record['dist'] = ["Background", getRateDistribution (["fits",m,"Rate Distributions","Background"]),"&omega;",m + " ω background" ];
          record['plot'] = ["ω",record['dist'][1]];
          table.push (record);
      }
      if (srv_rate_classes) {
        record = {'Model' : m};
        record['dist'] = ["Synonymous rates", getRateDistribution (["fits",m,"Rate Distributions","Synonymous site-to-site rates"], ["rate", "proportion"]),"",m + " syn rates" ];
        record['plot'] = ["",record['dist'][1]];
        table.push (record);
      }
  });*/
  return table;
  //getRateDistribution (["fits","Unconstrained model","Rate Distributions","Test"])
}


function _getRateDistribution(_,results_json){return(
(keys, tags)=> {
    tags = tags || ["omega", "proportion"];
    const rate_info = _.get (results_json, keys);
    if (rate_info) {

      
      return _.sortBy (_.map (rate_info, (d)=>({
        "value" : d[tags[0]],
        "weight" : d[tags[1]]
      })), (d)=>d.rate);
    }
    return null;
}
)}

function _partition_sizes(_,results_json)
{
    return _.chain (results_json['data partitions']).map ((d,k)=>(d['coverage'][0].length)).value();
}


function _siteIndexPartitionCodon(_,results_json)
{
    return _.chain (results_json['data partitions']).map ((d,k)=>_.map (d['coverage'][0], (site)=>[+k+1,site+1])).flatten().value();
}


function _siteTableData(_,profileBranchSites,results_json,siteIndexPartitionCodon,srv_distribution,distMean,d3,pv,html)
{
  let site_info = [];
  let index = 0;
  let bySite = _.groupBy (profileBranchSites, (d)=>d.site);
  _.each (results_json["data partitions"], (pinfo, partition)=> {
      _.each (pinfo["coverage"][0], (ignore, i)=> {
          
              let site_record = {
                  //'Partition' : siteIndexPartitionCodon[index][0],
                  'Codon' : siteIndexPartitionCodon[index][1],
              };

              const sll = _.get (results_json, ["Site Log Likelihood",'unconstrained',0,index]);
              if (sll) {
                site_record['LogL'] = sll;
              }
        
              if (srv_distribution) {
                  let site_srv = [];
                  _.each (srv_distribution, (d,i)=> {
                       site_srv.push ({'value' : d.value, 'weight' : results_json["Synonymous site-posteriors"][i][index]});
                  });
                  site_record['SRV posterior mean'] = distMean (site_srv);
              }

              site_record ["Subs"] = d3.sum (bySite[i+1], (d)=>d.subs);
              site_record ["ER"] = _.filter (bySite[i+1], (d)=>d.ER >= pv).length;
              
              site_info.push (site_record);
              index++;
          })  
        
      });
    return [site_info, {
      'Codon' : html`<abbr title = "Site">Codon</abbr>`,
      'SRV posterior mean' : html`<abbr title = "Posterior mean of the synonymous rate, α;">E<sub>post</sub>[α]</abbr>`,
      'LogL' : html`<abbr title = "Site log-likelihood under the unconstrained model">log(L)</abbr>`,
      'Subs' : html`<abbr title = "Total # of substitutions (s+ns)">Subs</abbr>`,
      'ER' : html`<abbr title = "Total # branches with evidence ratio > ${pv}">ER Branch</abbr>`,
    }];
}


function _sites_table(siteTableData)
{
    return [{}, siteTableData[0], siteTableData[1]];
}


function _profileBranchSites(_,results_json,generateNodeLabels,tree_objects,subs_for_pair)
{
  let results = [];
  const unc = _.get (results_json, ["Site Log Likelihood","unconstrained","0"]);
  const subs = _.get (results_json, ["substitutions","0"]);
  if (unc) {
    _.each (unc, (ll, i)=> {
        const subs_at_site = generateNodeLabels (tree_objects[0], subs[i]);
        _.each (subs_at_site, (info, node)=> {
      
             if (node != 'root') {
                const bs_ll = _.get (results_json, ["Site Log Likelihood","tested",node,0,i]);
                if (bs_ll) {
                    let bit = {};
                    bit.Key = node + "|" + (i+1);
                    bit.branch = node;
                    bit.site = i+1;
                    bit.ER = Math.exp (unc[i]-bs_ll);
                    bit.subs = info[3];
                    bit.from = info[2];
                    bit.to = info[0];
                    let sub_count = subs_for_pair (bit.from, bit.to);
                    bit.syn_subs = sub_count[0];
                    bit.nonsyn_subs = sub_count[1];
                    results.push (bit);
                }
              }
              
        });
    });
  }
  return results;
}


function _posteriorsPerBranchSite(_,results_json,test_omega,generateNodeLabels,tree_objects,subs_for_pair){return(
(do_counts, er)=> {
  let results = do_counts ? {} : [];
  let offset = 0;
  const subs = _.get (results_json, ["substitutions","0"]);
    
  _.each (results_json["branch attributes"], (data, partition) => {
      let partition_size = 0;
      let subs_per_site = {};
      _.each (data, (per_branch, branch)=> {
          if (per_branch ["posterior"]) {
            const prior_d = test_omega (branch);
            let prior_odds = prior_d[prior_d.length-1].weight;
            const rate_class = prior_d.length-1;
            if (prior_odds < 1 && prior_odds > 0) {
              prior_odds = prior_odds / (1-prior_odds);
              _.each (per_branch ["posterior"][rate_class], (p,i)=> {
                  if (! do_counts && (i in subs_per_site) == false) {
                      subs_per_site[i] = generateNodeLabels (tree_objects[0], subs[i])
                  }
                 
                  if (do_counts) {
                    results[branch] = (results[branch] ? results[branch] : 0) + ((p/(1-p))/prior_odds >= er);
                  } else {
                    const info = subs_per_site [i][branch];
                    let sub_count = subs_for_pair (info[2], info[0]);
                    results.push ({'Key' : branch + "|" + (i + offset + 1), 
                                   'Posterior' : p, 
                                   'ER' : (p/(1-p))/prior_odds,
                                   'subs' : info[3],
                                   'from': info[2],
                                   'to' : info[0],
                                   'syn_subs' : sub_count[0],
                                   'nonsyn_subs' : sub_count[1]
                                  });
                  }
              });
            }
            partition_size = per_branch ["posterior"][rate_class].length;
          }
      });
      offset += partition_size;
  });
  return results;
}
)}

function _characterPlot(treeNodeOrdering,results_json){return(
(data, data2)=> {
  const branch_order = treeNodeOrdering (0, true);
  let N = results_json.input["number of sequences"];
  let box_size = 10; 
  let font_size = 12;

  console.log (data2);
  
  let spec = {
      "width": {"step": 2.5*font_size},  "height" : {"step" : font_size},
      "data" : {"values" : 
        data,
      }, 
      "transform" : [
        {"calculate" : "parseInt (split(datum.Key, '|')[1])", "as" : "Codon"},
        {"calculate" : "split(datum.Key, '|')[0]", "as" : "Branch"},
        {"filter": {"param": "character_view", "empty" : true}},
        {
          "lookup": "Key",
          "from": {
            "data": {"values" : data2},
            "key": "Key",
            "fields": ["ER"]
          }
        }
      ],
     
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "ordinal",
          "scale": {"domain": {"selection": "character_view", "encoding": "x"}},
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Codon", "labelFontSize" : font_size} : null
        },
        "y": {
          "field": "Branch",
          "scale": {"domain": {"selection": "character_view", "encoding": "y"}},
          "type" : "ordinal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Branch", "labelFontSize" : font_size} : null
        }
      },
      "layer": [
        {
          "mark": {"type": "text", "clip" : true, "fontSize" : font_size, "font" : "monospace", "fontWeight" : "bold", "color" : "#444", "opacity" : 1.0, "tooltip" : true},
          "encoding": {
            "text" : {"field" : "value"},
            "color": {
               "field" : "aa"
               //"field": "ER",
                //"type" : "quantitative",
                //"legend" : {"orient" : "top"},
                //"sort": "ascending",
                //"scale" : {"scheme" : "lightgreyred"}
            }
          }
        }
      ]
  };
  return spec;
}
)}

function _table3_data(_,profileBranchSites,which_branch,bsPositiveSelection)
{
  let rc = _.keyBy (_.filter (profileBranchSites, (d)=>which_branch.indexOf (d.branch)>=0), (d)=>d.Key);
  _.each (bsPositiveSelection, (d)=> {
      if (d.Key in rc) {
          rc[d.Key].EBF = d.ER;
      }
  });
  return _.values (rc);
     
}


function _bsPositiveSelection(posteriorsPerBranchSite)
{
  return posteriorsPerBranchSite ();
}


function _path_diff(_,translate_ambiguous_codon){return(
(from,to,path)=> {
    let res = [0,0];
    let curr = _.map (from),
        next = _.clone (curr);
   
    next [path[0]] = to[path[0]];
    const is_syn = translate_ambiguous_codon (curr.join ("")) == translate_ambiguous_codon(next.join (""));
    res[is_syn ? 0 : 1] += 1;
    for (let i = 1; i < path.length; i++) {
        curr = _.clone (next);
        next [path[i]] = to[path[i]];
        const is_syn = translate_ambiguous_codon (curr.join ("")) == translate_ambiguous_codon(next.join (""));
        res[is_syn ? 0 : 1] += 1;
    }
  
    return res;
}
)}

function _subs_for_pair(_,translate_ambiguous_codon,path_diff){return(
(from, to) => {

    if (from == 'NNN' || to == 'NNN') {
        return [0,0];
    }
  
    let diffs = [];
    _.each (from, (c,i)=> {
      if (c != to[i]) {
          diffs.push (i);
      }
    });
    switch (diffs.length) {
      case 0:
          return [0,0];
      case 1:
          if (translate_ambiguous_codon (from) == translate_ambiguous_codon(to)) {
              return [1,0];
          }
          return [0,1];
      case 2: {
          let res = path_diff (from,to,[diffs[0],diffs[1]]);
          _.each (path_diff (from,to,[diffs[1],diffs[0]]), (d,i) => {res[i] += d;});
          return _.map (res, (d)=>0.5*d);
      }
       case 3: {
          let res = path_diff (from,to,[diffs[0],diffs[1],diffs[2]]);
          _.each (path_diff (from,to,[diffs[0],diffs[2],diffs[1]]), (d,i) => {res[i] += d;});
          _.each (path_diff (from,to,[diffs[1],diffs[0],diffs[2]]), (d,i) => {res[i] += d;});
          _.each (path_diff (from,to,[diffs[1],diffs[2],diffs[0]]), (d,i) => {res[i] += d;});
          _.each (path_diff (from,to,[diffs[2],diffs[0],diffs[1]]), (d,i) => {res[i] += d;});
          _.each (path_diff (from,to,[diffs[2],diffs[1],diffs[0]]), (d,i) => {res[i] += d;});
          return _.map (res, (d)=>d/6); 
       }
    }
}
)}

function _generateNodeLabels(translate_ambiguous_codon,_){return(
(T, labels)=> {
    let L = {};
    T.traverse_and_compute (function (n) {
        if (n.data.name in labels) {
            L[n.data.name] = [labels[n.data.name], translate_ambiguous_codon (labels[n.data.name]),'',0];
            if (n.parent) {
              L[n.data.name][2] = L[n.parent.data.name][0];             
              _.each (L[n.data.name][0], (c,i)=> {
                  const c2 = L[n.data.name][2][i];
                  if (c2 != c && c != '-' && c2 != '-' && c != 'N' && c2 != 'N') {
                    L[n.data.name][3] ++;
                  }
              });
            }
        } else {
          if (n.parent) {
            L[n.data.name] = _.clone (L[n.parent.data.name]);
            L[n.data.name][2] = L[n.data.name][0];
            L[n.data.name][3] = 0;
          } else {
            L['root'] = [labels["root"], translate_ambiguous_codon (labels["root"]), "", 0];
          }
        }
    },"pre-order");
    return L;
}
)}

function _treeNodeOrdering(tree_objects,d3,results_json){return(
(index, root)=> {
    let order = [];
    if (root) {order.push ('root');}
    const T = tree_objects[index];
    function sort_nodes (asc) {
        T.traverse_and_compute (function (n) {
                var d = 1;
                if (n.children && n.children.length) {
                    d += d3.max (n.children, function (d) { return d["count_depth"];});
                } 

                n["count_depth"] = d;
            });
        T.resortChildren (function (a,b) {
            return (a["count_depth"] - b["count_depth"]) * (asc ? 1 : -1);
        });
    }
    sort_nodes (true);
    T.traverse_and_compute (function (n) {
        if (results_json.tested[index][n.data.name] == "test") {
          order.push (n.data.name);
        }
    });
    return order;
}
)}

function _distMean(_){return(
(d)=> {
    let m = 0;
    _.each (d, (r)=> {
        m += r['value'] * r['weight'];
    });
    return m;
}
)}

function _distVar(distMean,_){return(
(d)=> {
    let m2 = 0, m = distMean (d);
    _.each (d, (r)=> {
        m2 += r['value']*r['value'] * r['weight'];
    });
    return m2 - m*m;
}
)}

function _er_step_size(results_json){return(
()=> {
    let N = results_json.input["number of sequences"];
    if (N < 100) return 70;
    if (N < 200) return 140;
    return 600;
}
)}

function _d3(require){return(
require ("d3")
)}

function _floatFmt(d3){return(
d3.format (".2g")
)}

function _seqNames(){return(
(tree)=> {
    let seq_names = [];
    tree.traverse_and_compute (n=>{
        if (n.children && n.children.length) return;
        seq_names.push (n.data.name);
    });
    return seq_names;
}
)}

function _dyn_range_cap(){return(
10000
)}

function _ERPlot(d3,dyn_range_cap,pv,_){return(
(data, from, step, key)=> {
  let scale = d3.extent (data, (d)=>d[key]); 
  scale[1] = Math.min (dyn_range_cap,Math.max (scale[1], pv));
  scale = d3.nice (scale[0], scale[1], 10);
  return {
      "width": {"step": 12},
      "data" : {"values" : _.map (
        _.filter (data, (d,i)=>i+1 >= from && i< from + step - 1),
      (d)=> {
          let dd = _.clone (d);
          _.each ([key], (f)=> {
            dd[f] = Math.min (dyn_range_cap, dd[f]);
          });
          return dd;
      })}, 
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "nominal",
          "axis": {"grid" : false, "titleFontSize" : 14, "title" : "Codon"}
        }
      },
      "layer": [
        {
          "mark": {"stroke": "black", "type": "line", "size" : 2, "interpolate" : "step", "color" : "lightgrey", "opacity" : 0.5},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
                "scale" : {"type" : "symlog", "domain" : scale},
                "axis" : {"grid" : false}
            }
          }
        },
        {
          "mark": { "stroke": "black", "type": "point", "size" : 100, "filled" : true,  "color" : "lightgrey", "tooltip" : {"contents" : "data"}, "opacity" : 1.},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
                
            },
            "color" : {"condition": {"test": "datum['" + key + "'] > " + pv, "value": "firebrick"},
                "value": "lightgrey"
            }
          }
        },
        {
          "mark" : {"opacity": 0.5, "type": "line", "color": "steelblue"},
          "encoding" : { "y": {
                "datum": {"expr": "" + pv},
                "type": "quantitative",
                "scale" : {"domain" : scale}
              },
             
            "size": {"value": 2},
          }
        }
        
      ]
  };
}
)}

function _SRVPlot(_,dyn_range_cap){return(
(data, from, step, key, key2)=> {
  let spec = {
      "width": {"step": 12},
      "data" : {"values" : _.map (
        _.filter (data, (d,i)=>i+1 >= from && i<= from + step),
      (d)=> {
          let dd = _.clone (d);
          _.each ([key], (f)=> {
            dd[f] = Math.min (dyn_range_cap, dd[f]);
          });
          return dd;
      })}, 
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "nominal",
          "axis": {"grid" : false, "titleFontSize" : 14, "title" : "Codon"}
        }
      },
      "layer": [
        {
          "mark": {"type": "line", "size" : 2, "color" : "lightgrey", "opacity" : 0.5, "interpolate" : "step"},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
            }
          }
        },
        {
          "mark": {"stroke": null, "type": "point", "size" : 100, "filled" : true, "color" : "lightgrey", "tooltip" : {"contents" : "data"}, "opacity" : 1},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
                "scale" : {"type" : "symlog"},
                "axis" : {"grid" : false}
            },
            //"color" : results_json["Evidence Ratios"]["constrained"] ? {"field" : "ER (constrained)", "type" : "quantitative", "scale" : {"type" : "log", "scheme": "turbo"}, "legend" : {"orient" : "top"}} : null
          }
        }
      ]
  };
  if (key2) {
      spec.layer.push (
        {
          "mark": {"type": "line", "size" : 4, "color" : "lightgrey", "opacity" : 0.5, "interpolate" : "step", "color" : "firebrick"},
          "encoding": {
            "y": {
               "field": key2,
                "type" : "quantitative",
            }
          }
        }
      );
  }
  return spec;
}
)}

function _BSPosteriorPlot(_,rate_table,treeNodeOrdering,profilable_branches,tested_branch_count,fig1_controls){return(
(data, from, step)=> {
  const selected_branches = new Set (_.map (rate_table, (d)=>d.branch));
  const branch_order = _.filter (treeNodeOrdering (0), (d)=>profilable_branches.has (d) && selected_branches.has (d));
  let N = tested_branch_count;
  let box_size = 10; 
  let font_size = 8;
  var size_field = "subs";
  switch (fig1_controls) {
    case "Syn subs":
      size_field = "syn_subs";
      break;
    case "Nonsyn subs":
      size_field = "nonsyn_subs";
      break;
  }
  
  if (N > 50) {
      if (N <= 100) {box_size = 8; font_size = 6;}
      else if (N <= 200) {box_size = 5; font_size = 5;}
      else {box_size = 4; font_size = 0;}
  }
  let spec = {
      "width": {"step": box_size}, "height" : {"step" : box_size},
      "data" : {"values" : 
        _.filter (data, (d)=>selected_branches.has (d.Key.split ("|")[0]))
      }, 
      "transform" : [
        {"calculate" : "parseInt (split(datum.Key, '|')[1])", "as" : "Codon"},
        {"calculate" : "split(datum.Key, '|')[0]", "as" : "Branch"},
        {"filter" : {"field" : "Codon", "range" : [from, from+step-1]}}
      ],
      /*"params": [{
        "name": "character_view",
        "select": {
          "type": "interval",
          "encodings": ["x","y"],
          "nearest" : "true",
          "mark" : {"stroke" : "#444", "strokeWidth" : 3},
        },
        "value": {"x": _.range (20), "y": branch_order}
      }],*/
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "nominal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Codon", "labelFontSize" : font_size} : null
        },
        "y": {
          "field": "Branch",
          "scale" : {"domain" : branch_order},
          "type" : "nominal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Branch", "labelFontSize" : font_size} : null
        }
      },
      "layer": [
        {
          "mark": {"type": "rect", "size" : 2, "color" : "lightgrey", "opacity" : 1.0, "tooltip" : {"contents" : "data"}},
          "encoding": {
            "color": {
               "field": "ER",
                "type" : "quantitative",
                "legend" : {"orient" : "top", "title" : "EBF"},
                "sort": "descending",
                "scale" : {"type" : "log", "scheme" : "redyellowblue", "domainMid" : 1}
            }
          }
        },
        {
          "mark": {"type": "circle", "size" : 2, "stroke" : "black", "strokeWidth" : 0.5, "color" : null, "opacity" : 1.0},
          "encoding": {
            "color" : {"value" : null},
            "size": {
               "field": size_field,
                "type" : "quantitative",
                "legend" : {"orient" : "top", "title" : "# substitutions"}
            }
          }
        }
      ]
  };
  return spec;
}
)}

function _ERPosteriorPlot(_,rate_table,treeNodeOrdering,profilable_branches,tested_branch_count,fig1_controls){return(
(data, from, step)=> {
  
  const selected_branches = new Set (_.map (rate_table, (d)=>d.branch));
  const branch_order = _.filter (treeNodeOrdering (0), (d)=>profilable_branches.has (d) && selected_branches.has (d));
  let N = tested_branch_count;
  let box_size = 10; 
  let font_size = 8;

  var size_field = "subs";
  switch (fig1_controls) {
    case "Syn subs":
      size_field = "syn_subs";
      break;
    case "Nonsyn subs":
      size_field = "nonsyn_subs";
      break;
  }
  
  if (N > 50) {
      if (N <= 100) {box_size = 8; font_size = 6;}
      else if (N <= 200) {box_size = 5; font_size = 5;}
      else {box_size = 4; font_size = 0;}
  }
  let spec = {
      "width": {"step": box_size}, "height" : {"step" : box_size},
      "data" : {"values" : 
        _.filter (data, (d)=>selected_branches.has (d.Key.split ("|")[0]))
      }, 
      "transform" : [
        {"calculate" : "parseInt (split(datum.Key, '|')[1])", "as" : "Codon"},
        {"calculate" : "split(datum.Key, '|')[0]", "as" : "Branch"},
        {"filter" : {"field" : "Codon", "range" : [from, from+step-1]}},
      ],
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "nominal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Codon", "labelFontSize" : font_size} : null
        },
        "y": {
          "field": "Branch",
          "scale" : {"domain" : branch_order},
          "type" : "nominal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Branch", "labelFontSize" : font_size} : null
        }
      },
      "layer": [
        {
          "mark": {"type": "rect", "size" : 2, "color" : "lightgrey", "opacity" : 0.8, "tooltip": {"content": "data"}},
          "encoding": {
            "color": {
               "field": "ER",
                "type" : "quantitative",
                "legend" : {"orient" : "top"},
                "sort": "descending",
                "scale" : {"type" : "log", "scheme" : "redyellowblue", "domainMid" : 1}
            }
          }
        },
        {
          "mark": {"type": "circle", "size" : 2, "stroke" : "black", "strokeWidth" : 0.5, "color" : null, "opacity" : 1.0},
          "encoding": {
            "color" : {"value" : null},
            "size": {
               "field": size_field,
                "type" : "quantitative",
                "legend" : {"orient" : "top", "title" : "# substitutions"}
            }
          }
        }
      ]
  };
  return spec;
}
)}

function __(require){return(
require("lodash")
)}

function _tree_objects(_,results_json,phylotree){return(
_.map (results_json.input.trees, (tree,i)=> {
  let T = new phylotree.phylotree (tree);
  T.branch_length_accessor = (n)=>results_json["branch attributes"][i][n.data.name]["Global MG94xREV"];
  return T;
})
)}

function _totalTreeLength(){return(
(tree)=> {
  let L = 0;
  tree.traverse_and_compute ( (n)=> {
     if (tree.branch_length (n)) {
      L += +tree.branch_length (n);
     }
  });
  return L;
}
)}

function _subs_by_branch(_,results_json){return(
(i)=>{
    let counts = {};
    _.each (results_json.substitutions[i], (states, site)=> {
        _.each (states, (state, branch)=> {
          if (branch != "root") {
              if (state != '---') {
                    counts[branch] = 1 + (counts[branch] ? counts[branch] : 0);
              }
          }
        });
    });
    return counts;
}
)}

function _site_support_by_branch(_,results_json){return(
(i, key, er)=> {
    let counts = {};
    _.each (results_json["branch attributes"][i], (attribs, branch)=> {
        if (key in attribs) {
          _.each (attribs[key], (d)=> {
            if (d[1] >= er) {
              counts[branch] = 1 + (counts[branch] ? counts[branch] : 0);
            }
          });
        }});
    return counts;
}
)}

function _label_color_scale(d3){return(
d3.scaleOrdinal([], d3.schemeCategory10)
)}

function _display_tree(treeDim,_,results_json,branch_length,treeLabels,add_svg_defs,d3,color_branches,test_omega,test_pv,add_branch_label,subs_by_branch,mh_rates){return(
(index, T, options) => {
      let dim = treeDim.length ? _.map (treeDim.split ("x"), (d)=>+d) : null;
    
      T.branch_length_accessor = (n)=>(n.data.name in results_json["branch attributes"][index] ? results_json["branch attributes"][index][n.data.name][branch_length] : 0) || 0;  
      let alignTips = treeLabels.indexOf ("align tips") >= 0;
      var t = T.render({
        height: dim && dim[0], 
        width : dim && dim[1],
        'align-tips' : alignTips,
        'selectable' : false,
        'show-scale' : true,
        'is-radial' : false,
        'left-right-spacing': 'fit-to-size', 
        'top-bottom-spacing': 'fit-to-size',
        'node_circle_size' : (n)=>0,
        'internal-names' : treeLabels.indexOf ("show internal") >= 0
       } );
      

      add_svg_defs (t.svg);
  
      function sort_nodes (asc) {
          T.traverse_and_compute (function (n) {
                  var d = 1;
                  if (n.children && n.children.length) {
                      d += d3.max (n.children, function (d) { return d["count_depth"];});
                  } 

                  n["count_depth"] = d;
              });
          T.resortChildren (function (a,b) {
              return (a["count_depth"] - b["count_depth"]) * (asc ? 1 : -1);
          });
        }

        sort_nodes (true);
        t.style_nodes ((e,n) => {
           e.selectAll ("text").style ("font-family", "ui-monospace");
           if (n.children && n.children.length) return; 
           e.selectAll ("title").data ([n.data.name]).join ("title").text ((d)=>d);

        });

    
        if (color_branches == "Tested") {
          t.style_edges ((e,n) => {
             const is_tested = results_json["tested"][index][n.target.data.name] == "test";
             if (is_tested) {
                e.style ("stroke", "firebrick"); 
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (color_branches == "Support for selection") {
            let branch_values = {};
            t.svg.selectAll ("defs").selectAll ("linearGradient").remove();
            let branch_gradients = {};
            T.traverse_and_compute ( (n)=> {
                  let test_omegas = test_omega (n.data.name);
                  if (test_omegas) {
                    let rate_class = test_omegas.length - 1 ;
                    branch_values[n.data.name] = test_omegas[rate_class].value;
                  }
                  
                }
            );
            let color_scale = d3.scaleDivergingLog([1e-4,1,Math.min(1000,d3.max (_.map (branch_values, (d)=>d)))],["rgb(0,0,255)","rgb(128,128,128)","rgb(255,0,0)"]);
          
            let bID = 0;
            let max_omega_by_branch = {};
            T.traverse_and_compute ( (n)=> {
                  let test_omegas = test_omega (n.data.name);
                  if (test_omegas) {
                    let rate_class = test_omegas.length - 1 ;
                    branch_gradients [n.data.name] = "hyphy_phylo_branch_gradient_" + bID;
                    
                    let gradient_def = t.svg.selectAll ("defs").append ("linearGradient").attr ("id", branch_gradients [n.data.name]);
                    bID += 1;
                    let current_frac = 0;
                    _.each (test_omegas, (t)=> {
                        gradient_def.append ("stop").attr ("offset", "" + current_frac*100.0 + "%").style ("stop-color", color_scale (t.value));
                        
                        current_frac += t.weight;
                        gradient_def.append ("stop").attr ("offset", "" + current_frac*100.0 + "%").style ("stop-color", color_scale (t.value));                    });
                      max_omega_by_branch [n.data.name] = test_omegas[test_omegas.length-1];
                  }
                  
                  
                }
            ); 
            
            t.color_scale = color_scale;
            t.color_scale_title = "ω";
            t.style_edges ((e,n) => {
               const is_tested = results_json["tested"][index][n.target.data.name] == "test";
               let t_string = n.target.data.name + " ";
               let b_string = "";
               if (is_tested) {
                   let pv_l = test_pv (n.target.data.name); 
                   t_string += "(p = " + pv_l.toFixed (3) + ")";
                   pv_l = -Math.floor(Math.log10(Math.max (pv_l,1e-6)));
                   let mxo = max_omega_by_branch[n.target.data.name].value;
                   if (mxo > 1) {
                         mxo = mxo > 1000. ? ">1000" : mxo.toFixed (2);
                         b_string = mxo + "/" + (max_omega_by_branch[n.target.data.name].weight*100).toFixed (2) + "%"; 
                   }
                  
                   e.style ("stroke", "url('#" + branch_gradients[n.target.data.name] + "')").style ("stroke-width", 2 + pv_l);
               } else {
                   t_string += "(not tested)";
                   e.style ("stroke", "url('#" + branch_gradients[n.target.data.name] + "')").style ("stroke-width", "2").style ("opacity","0.5");
               }
               t_string += " max ω = " + branch_values[n.target.data.name].toFixed (2);
               e.style ("stroke-linejoin", "round").style("stroke-linecap", "round");
               e.selectAll ("title").data ([t_string]).join ("title").text ((d)=>d);
               if (options["branch-labels"]) {
                    add_branch_label (e, b_string, t.font_size, t.svg.selectAll (".phylotree-container"));
               }
            });
        } else {
            let labels;
            switch (color_branches) {
              case "Substitutions" : {  
                labels = subs_by_branch (index);
                 t.color_scale_title = "Min # of nucleotide substitutions";
                } 
                break;
              case "2-hit rate" : {  
                 labels = _.mapValues (mh_rates["DH"], d=>d.toFixed (2));
                 t.color_scale_title = "Double-nucleotide relative substitution rate (δ)";
                } 
                break;
              case "3-hit rate" : {  
                 labels = _.mapValues (mh_rates["TH"], d=>d.toFixed (2));
                 t.color_scale_title = "Three-nucleotide relative substitution rate (ψ)";
                } 
                break;
            }

            //console.log (labels, options["branch-labels"]);
          
            let color_scale = d3.scaleSequential(d3.extent (_.map (labels, d=>d)), d3.interpolateTurbo);
            t.color_scale = color_scale;

            t.svg.selectAll (".absrel-branch-labels").remove();
            
            t.style_edges ((e,n) => {
                const is_tested = labels[n.target.data.name];
                if (options["branch-labels"]) {
                    add_branch_label (e, is_tested, t.font_size, t.svg.selectAll (".phylotree-container"));
                }
                e.style ("stroke", color_scale(is_tested)).style ("stroke-width", "4").style ("opacity",1.0); 
                e.selectAll ("title").data ([is_tested]).join ("title").text ((d)=>d);
                e.style ("stroke-linejoin", "round").style("stroke-linecap", "round");
          });
        }

      
      t.placenodes();
      t.update();
      //label_color_scale.domain (labelDomain);
      return t;     
}
)}

function _display_tree_handle_neighbors(generateNodeLabels,_){return(
(index, s, node_labels, T, options, results, site_count)=> {
  let extended_labels = {};
  if (options["neighbors"]) {
        const si = (+s)-1;
        //const site_count = partition_sizes[index];
        let joint_labels = [];
        for (let idx = si-4; idx <= si+4; idx++) {
              if (idx >= 0 && idx <= site_count) {
                    if (idx != si) {
                        joint_labels.push (generateNodeLabels (T, results["substitutions"][index][idx]));
                    } else {
                        joint_labels.push (_.mapValues (node_labels, (d)=> {
                              return ["·" + d[0] + "·", "·" + d[1] + "·"] 
                        }));
                    }
              }
        } 
        _.each (node_labels, (d,k)=> {
            extended_labels [k] = [_.map (joint_labels, (slc)=> {
                return slc[k][0];
            }).join ("|"),_.map (joint_labels, (slc)=> {
                return slc[k][1];
            }).join ("|")];
        });


    }
    return extended_labels;
}
)}

function _display_tree_site(treeDim,_,results_json,branch_length,generateNodeLabels,treeLabels,add_svg_defs,display_tree_handle_neighbors,partition_sizes,d3,label_color_scale,color_branches,test_omega,mh_rates,add_branch_label){return(
(index, T,s,options) => {
    let dim = treeDim.length ? _.map (treeDim.split ("x"), (d)=>+d) : null;
    
    T.branch_length_accessor = (n)=>results_json["branch attributes"][index][n.data.name][branch_length] || 0;  
    let node_labels = generateNodeLabels (T, results_json["substitutions"][index][(+s)-1]);
    let extended_labels = {};

    let labelDomain = new Set();
    let showAA = treeLabels.indexOf ("amino-acids") >= 0;
    let showCodons = treeLabels.indexOf ("codons") >= 0;
    let showSeqNames = treeLabels.indexOf ("sequence names") >= 0;
    let showOnlyMH = treeLabels.indexOf ("show only multiple hits") >= 0;
    let showOnlyNS = treeLabels.indexOf ("show only non-synonymous changes") >= 0;
    let alignTips = treeLabels.indexOf ("align tips") >= 0;
    

  
    var t = T.render({
      height:dim && dim[0], 
      width:dim && dim[1],
      'show-scale' : true,
      'is-radial' : false,
      'align-tips' : alignTips,
      'left-right-spacing': 'fit-to-size', 
      'top-bottom-spacing': 'fit-to-size',
      'node_circle_size' : (n)=>0,
      'selectable' : false,
      'internal-names' : treeLabels.indexOf ("show internal") >= 0
     } );

      
      add_svg_defs (t.svg);
      extended_labels = display_tree_handle_neighbors (index,s,node_labels,T,options,results_json, partition_sizes[index]);
  
  
      t.nodeLabel ((n)=> {
          if (!n._display_me) {
              return "";
          }
          let label = "";
          let has_extended_label = extended_labels[n.data.name] || node_labels[n.data.name];

          n.data.color_on = "";
          
          if (showCodons) {
                label = has_extended_label[0];
                n.data.color_on = node_labels[n.data.name][0];
                if (showAA) label += "/";
          }
        
          if (showAA) {
              label += has_extended_label[1];
              n.data.color_on = node_labels[n.data.name][1];
          }
          
          labelDomain.add ( n.data.color_on);
          if (showSeqNames) label += ":" + n.data.name;
          return label;
      });
      
      function sort_nodes (asc) {
          T.traverse_and_compute (function (n) {
                  var d = 1;
                  if (n.children && n.children.length) {
                      d += d3.max (n.children, function (d) { return d["count_depth"];});
                  } 

                  n["count_depth"] = d;
              });
          T.resortChildren (function (a,b) {
              return (a["count_depth"] - b["count_depth"]) * (asc ? 1 : -1);
          });
        }

       T.traverse_and_compute (function (n) {
            n._display_me = ! (showOnlyMH || showOnlyNS);
         
            if (!n._display_me) {
                if (node_labels[n.data.name]) {
                    if (showOnlyMH && node_labels[n.data.name][3] > 1) n._display_me = true;
                    if (! n._display_me) {
                      if (showOnlyNS) {
                          if (n.parent) {
                              const my_aa = node_labels[n.data.name][1];
                              const parent_aa = node_labels[n.parent.data.name][1];
                              if (my_aa != parent_aa && my_aa != '-' && parent_aa != '-') {
                                  n._display_me = true;
                                  
                                  if (showOnlyMH) n._display_me = node_labels[n.data.name][3] > 1;
                              } else {
                                  n._display_me = false;
                              }
                          }
                      }
                    }
                }
            }
            if (n._display_me && n.parent) {
                n.parent._display_me = true;
            }
            
        },"pre-order");

        sort_nodes (true);
        t.style_nodes ((e,n) => {
           e.selectAll ("text").style ("fill", label_color_scale(n.data.color_on));
           e.selectAll ("title").data ([n.data.name]).join ("title").text ((d)=>d);
           e.selectAll ("text").style ("font-family", "ui-monospace");
        });
       
    
        if (color_branches == "Tested") {
          t.style_edges ((e,n) => {
             const is_tested = results_json["tested"][index][n.target.data.name] == "test";
             if (is_tested) {
                e.style ("stroke", "firebrick"); 
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (color_branches == "Support for selection") {
            let branch_values = {};
            
            T.traverse_and_compute ( (n)=> {
              
                let posteriors = results_json["branch attributes"][index][n.data.name];
                if (posteriors && posteriors["posterior"]) {
                    let test_omegas = test_omega (n.data.name);
                    let rate_class = test_omegas.length - 1 ;
                    let prior = test_omegas[test_omegas.length-1].weight;
                    prior = prior / (1-prior);
                    posteriors = posteriors["posterior"][rate_class][s-1];
                    branch_values [n.data.name] = posteriors/(1-posteriors)/prior;
                    if (branch_values [n.data.name] < 1) branch_values [n.data.name] = null;
                }
               
            });
            let color_scale = d3.scaleSequentialLog(d3.extent (_.map (branch_values, (d)=>d)),d3.interpolateTurbo);
            t.color_scale = color_scale;
            t.color_scale_title = "Empirical Bayes Factor";
            t.style_edges ((e,n) => {
             const is_tested = branch_values[n.target.data.name];
             if (is_tested) {
                e.style ("stroke", color_scale(is_tested)).style ("stroke-width", "5").style ("opacity",null); 
                e.selectAll ("title").data ([is_tested]).join ("title").text ((d)=>d);
             } else {
                e.style ("stroke", null); 
             }
          });
        } else {
            let labels, color_scale = null;
            switch (color_branches) {
              case "Substitutions" : {  
                 color_scale = d3.scaleOrdinal([0,1,2,3], d3.schemePuOr[4]);
                 labels = node_labels;
                 t.color_scale_title = "Min # of nucleotide substitutions";
                } 
                break;
              case "2-hit rate" : {  
                 labels = _.mapValues (mh_rates["DH"], (d)=>d.toFixed(2));
                 t.color_scale_title = "Double-nucleotide relative substitution rate (δ)";
                } 
                break;
              case "3-hit rate" : {  
                 labels = _.mapValues (mh_rates["TH"], (d)=>d.toFixed(2));
                 t.color_scale_title = "Three-nucleotide relative substitution rate (ψ)";
                } 
                break;
            }
          
            
            t.color_scale = color_scale ||  d3.scaleSequential(d3.extent (_.map (labels, d=>d)), d3.interpolateTurbo);
            
            t.style_edges ((e,n) => {
             const is_tested = labels[n.target.data.name];
             if (color_branches == "Substitutions") {
               if (is_tested && is_tested[3]) {
                  e.style ("stroke", t.color_scale(is_tested[3])).style ("stroke-width", "5").style ("opacity","1"); 
                  const ts = is_tested[2] + "→" + is_tested[0] + "(" + is_tested[3] + ")"
                  e.selectAll ("title").data ([ts]).join ("title").text ((d)=>d);
                  if (options["branch-labels"]) {
                    add_branch_label (e, ts, t.font_size, t.svg.selectAll (".phylotree-container"));
                   }
               } else {
                  e.style ("stroke", null); 
               }
             } else {
                 e.style ("stroke", t.color_scale(is_tested)).style ("stroke-width", "4").style ("opacity","1"); 
                 if (options["branch-labels"]) {
                    add_branch_label (e, is_tested, t.font_size, t.svg.selectAll (".phylotree-container"));
                 }
             }
             
          });
        } 
        t.placenodes();
        t.update();
        label_color_scale.domain (labelDomain);
        return t;      
    }
)}

function _add_branch_label(_,parse_svg,DOM){return(
(e, text, font_size, container) => {
  const where2 = _.get (parse_svg.default(e.attr("d")),["1"]);
  //console.log (text);
  if (where2 && (text.length || _.isNumber (text))) {
      let my_id = e.attr ("id");
      if (!e.attr ("id")) {
          my_id = DOM.uid ("absrel_tree").id;
          e.attr ("id", my_id);
      }
      //t.svg.selectAll (".phylotree-container")
      let branch_label = container.selectAll ("text[label-for='" + my_id + "']").data ([text]).join ("text").attr ("label-for", my_id).text ((d)=>d).classed ("absrel-branch-labels",true).attr ("x", where2[1]).attr ("y", where2[2]).attr ("font-size", font_size * 0.8).attr ("dx","0.5em").attr ("dy", "-0.4em").style ("font-family", "ui-monospace");
      branch_label.attr ("filter","url(#tree_branchlabel_bgfill)");
  }
}
)}

function _add_svg_defs(){return(
(svg)=> {
    let filter = svg.selectAll ("defs").append ("filter").attr ("x", 0).attr ("y", 0).attr ("width", 1).attr ("height", 1).attr ("id", "tree_branchlabel_bgfill");
    filter.append ("feFlood").attr ("flood-color", "lightgray");
    filter.append ("feComposite").attr ("in", "SourceGraphic").attr ("operator", "atop");
}
)}

function _treeViewOptions(results_json,_)
{
  let opts = ["Alignment-wide tree"];
  if (results_json.substitutions) {
    opts = opts.concat(_.map (_.range (1,results_json.input["number of sites"]+1), (d)=>"Codon " + d));
  }
  return opts;
}


function _tree_color_options(results_json,_,mh_rates)
{
  let options = ["Tested"];
  if (results_json.substitutions) {
    options.push ("Support for selection");
    options.push ("Substitutions");
  }
  if (_.size (mh_rates['DH'])) {
      options.push ("2-hit rate");
  }
  if (_.size (mh_rates['TH'])) {
      options.push ("3-hit rate");
  }
  
  return options;
}


function _phylotree(require){return(
require ("phylotree")
)}

function _vegalite(require){return(
require ("vega-embed")
)}

function _params(URLSearchParams,location){return(
new URLSearchParams(location.search)
)}

function _pako(require){return(
require('pako@2.1.0/dist/pako.min.js')
)}

function _parse_svg(){return(
import(/* webpackIgnore: true */ 'https://cdn.skypack.dev/parse-svg-path@0.1.2?min')
)}

function _bustedStyle(html){return(
html`<style>

.stati{
  background: #fff;
  height: 4.5em;
  padding:0.5em;
  margin:0.25em 0; 
    -webkit-transition: margin 0.5s ease,box-shadow 0.5s ease; /* Safari */
    transition: margin 0.5s ease,box-shadow 0.5s ease; 
  -moz-box-shadow:0px 0.2em 0.4em rgb(0, 0, 0,0.8);
-webkit-box-shadow:0px 0.2em 0.4em rgb(0, 0, 0,0.8);
box-shadow:0px 0.2em 0.4em rgb(0, 0, 0,0.8);
}
.stati i{
  font-size:2.0em; 
} 
.stati div{
  width: calc(100% - 3.5em);
  display: block;
  float:right;
  text-align:right;
}
.stati div b {
  font-size:1.8em;
  width: 100%;
  padding-top:0px;
  margin-top:-0.2em;
  margin-bottom:-0.2em;
  display: block;
}
.stati div span {
  font-size:1em;
  width: 100%;
  color: rgb(0, 0, 0,0.8); !important;
  display: block;
}

.stati.left div{ 
  float:left;
  text-align:left;
}

.stati.bg-turquoise { background: rgb(26, 188, 156); color:white;} 
.stati.bg-emerald { background: rgb(46, 204, 113); color:white;} 
.stati.bg-peter_river { background: rgb(52, 152, 219); color:white;} 
.stati.bg-amethyst { background: rgb(155, 89, 182); color:white;} 
.stati.bg-wet_asphalt { background: rgb(52, 73, 94); color:white;} 
.stati.bg-green_sea { background: rgb(22, 160, 133); color:white;} 
.stati.bg-nephritis { background: rgb(39, 174, 96); color:white;} 
.stati.bg-belize_hole { background: rgb(41, 128, 185); color:white;} 
.stati.bg-wisteria { background: rgb(142, 68, 173); color:white;} 
.stati.bg-midnight_blue { background: rgb(44, 62, 80); color:white;} 
.stati.bg-sun_flower { background: rgb(241, 196, 15); color:white;} 
.stati.bg-carrot { background: rgb(230, 126, 34); color:white;} 
.stati.bg-alizarin { background: rgb(231, 76, 60); color:white;} 
.stati.bg-clouds { background: rgb(236, 240, 241); color:white;} 
.stati.bg-concrete { background: rgb(149, 165, 166); color:white;} 
.stati.bg-orange { background: rgb(243, 156, 18); color:white;} 
.stati.bg-pumpkin { background: rgb(211, 84, 0); color:white;} 
.stati.bg-pomegranate { background: rgb(192, 57, 43); color:white;} 
.stati.bg-silver { background: rgb(189, 195, 199); color:white;} 
.stati.bg-asbestos { background: rgb(127, 140, 141); color:white;} 
  

.stati.turquoise { color: rgb(26, 188, 156); } 
.stati.emerald { color: rgb(46, 204, 113); } 
.stati.peter_river { color: rgb(52, 152, 219); } 
.stati.amethyst { color: rgb(155, 89, 182); } 
.stati.wet_asphalt { color: rgb(52, 73, 94); } 
.stati.green_sea { color: rgb(22, 160, 133); } 
.stati.nephritis { color: rgb(39, 174, 96); } 
.stati.belize_hole { color: rgb(41, 128, 185); } 
.stati.wisteria { color: rgb(142, 68, 173); } 
.stati.midnight_blue { color: rgb(44, 62, 80); } 
.stati.sun_flower { color: rgb(241, 196, 15); } 
.stati.carrot { color: rgb(230, 126, 34); } 
.stati.alizarin { color: rgb(231, 76, 60); } 
.stati.clouds { color: rgb(236, 240, 241); } 
.stati.concrete { color: rgb(149, 165, 166); } 
.stati.orange { color: rgb(243, 156, 18); } 
.stati.pumpkin { color: rgb(211, 84, 0); } 
.stati.pomegranate { color: rgb(192, 57, 43); } 
.stati.silver { color: rgb(189, 195, 199); } 
.stati.asbestos { color: rgb(127, 140, 141); } 
  </style>
`
)}

function _simpleIcons(html){return(
html`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/simple-line-icons/2.4.1/css/simple-line-icons.css">`
)}

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], _1);
  main.variable(observer("viewof results_file")).define("viewof results_file", ["params","localFileInput"], _results_file);
  main.variable(observer("results_file")).define("results_file", ["Generators", "viewof results_file"], (G, _) => G.input(_));
  main.variable(observer("intro")).define("intro", ["md","results_json","floatFormat","srv_rate_classes","_","mh_rates"], _intro);
  main.variable(observer("citation")).define("citation", ["md","results_json"], _citation);
  main.variable(observer("viewof pv")).define("viewof pv", ["Inputs","html"], _pv);
  main.variable(observer("pv")).define("pv", ["Generators", "viewof pv"], (G, _) => G.input(_));
  main.variable(observer("summary_table")).define("summary_table", ["html","results_json","tested_branch_count","d3","omega_rate_classes","srv_rate_classes","floatFmt","_","distributionTable","pv","mh_rates"], _summary_table);
  main.variable(observer("alignmentHeader")).define("alignmentHeader", ["md"], _alignmentHeader);
  main.variable(observer("viewof rate_table")).define("viewof rate_table", ["Inputs","distributionTable","html","_","results_json","d3","floatFormat","proportionFormat","distMean","distVar","renderDiscreteDistribution"], _rate_table);
  main.variable(observer("rate_table")).define("rate_table", ["Generators", "viewof rate_table"], (G, _) => G.input(_));
  main.variable(observer("distComparisonPlot")).define("distComparisonPlot", ["rate_table","renderTwoDiscreteDistributions","md"], _distComparisonPlot);
  main.variable(observer("viewof tree_id")).define("viewof tree_id", ["autoSelect","treeViewOptions","html"], _tree_id);
  main.variable(observer("tree_id")).define("tree_id", ["Generators", "viewof tree_id"], (G, _) => G.input(_));
  main.variable(observer("viewof branch_length")).define("viewof branch_length", ["Inputs","_","results_json","html"], _branch_length);
  main.variable(observer("branch_length")).define("branch_length", ["Generators", "viewof branch_length"], (G, _) => G.input(_));
  main.variable(observer("viewof treeLabels")).define("viewof treeLabels", ["Inputs","html"], _treeLabels);
  main.variable(observer("treeLabels")).define("treeLabels", ["Generators", "viewof treeLabels"], (G, _) => G.input(_));
  main.variable(observer("viewof color_branches")).define("viewof color_branches", ["Inputs","tree_color_options","html"], _color_branches);
  main.variable(observer("color_branches")).define("color_branches", ["Generators", "viewof color_branches"], (G, _) => G.input(_));
  main.variable(observer("viewof treeDim")).define("viewof treeDim", ["Inputs"], _treeDim);
  main.variable(observer("treeDim")).define("treeDim", ["Generators", "viewof treeDim"], (G, _) => G.input(_));
  main.variable(observer()).define(["tree_id","figure2","Legend","html"], _15);
  main.variable(observer()).define(["figure2","md"], _16);
  main.variable(observer("fig1caption")).define("fig1caption", ["md","plot_type","plot_legends"], _fig1caption);
  main.variable(observer("viewof plot_type")).define("viewof plot_type", ["Inputs","_","plot_options","results_json","html"], _plot_type);
  main.variable(observer("plot_type")).define("plot_type", ["Generators", "viewof plot_type"], (G, _) => G.input(_));
  main.variable(observer("viewof fig1_controls")).define("viewof fig1_controls", ["plot_extras","plot_type","Inputs"], _fig1_controls);
  main.variable(observer("fig1_controls")).define("fig1_controls", ["Generators", "viewof fig1_controls"], (G, _) => G.input(_));
  main.variable(observer("figure1")).define("figure1", ["plot_type","vegalite","plot_specs","md"], _figure1);
  main.variable(observer("table1caption")).define("table1caption", ["md"], _table1caption);
  main.variable(observer("viewof table1")).define("viewof table1", ["Inputs","sites_table"], _table1);
  main.variable(observer("table1")).define("table1", ["Generators", "viewof table1"], (G, _) => G.input(_));
  main.variable(observer("table3caption")).define("table3caption", ["md"], _table3caption);
  main.variable(observer("viewof which_branch")).define("viewof which_branch", ["multiAutoSelect","_","profilable_branches"], _which_branch);
  main.variable(observer("which_branch")).define("which_branch", ["Generators", "viewof which_branch"], (G, _) => G.input(_));
  main.variable(observer("viewof table3")).define("viewof table3", ["Inputs","table3_data"], _table3);
  main.variable(observer("table3")).define("table3", ["Generators", "viewof table3"], (G, _) => G.input(_));
  main.variable(observer()).define(["html","resolve"], _26);
  main.variable(observer()).define(["md"], _27);
  main.variable(observer("figure2")).define("figure2", ["tree_id","treeLabels","siteIndexPartitionCodon","display_tree_site","tree_objects","display_tree"], _figure2);
  main.variable(observer("floatFormat")).define("floatFormat", ["d3"], _floatFormat);
  main.variable(observer("percentageFormat")).define("percentageFormat", ["d3"], _percentageFormat);
  main.variable(observer("proportionFormat")).define("proportionFormat", ["d3"], _proportionFormat);
  main.variable(observer("results_json")).define("results_json", ["get_json","params"], _results_json);
  main.variable(observer("get_json")).define("get_json", ["pako","d3","results_file"], _get_json);
  main.variable(observer("fig1data")).define("fig1data", ["_","table1","siteTableData"], _fig1data);
  main.variable(observer("plot_legends")).define("plot_legends", _plot_legends);
  main.variable(observer("plot_extras")).define("plot_extras", ["Inputs"], _plot_extras);
  main.variable(observer("plot_options")).define("plot_options", ["srv_rate_classes","srv_distribution","bsPositiveSelection","profileBranchSites"], _plot_options);
  main.variable(observer("plot_specs")).define("plot_specs", ["_","fig1data","SRVPlot","results_json","er_step_size","BSPosteriorPlot","bsPositiveSelection","ERPosteriorPlot","profileBranchSites"], _plot_specs);
  main.variable(observer("profilable_branches")).define("profilable_branches", ["_","results_json"], _profilable_branches);
  main.variable(observer("tested_branch_count")).define("tested_branch_count", ["d3","_","results_json"], _tested_branch_count);
  main.variable(observer("srv_rate_classes")).define("srv_rate_classes", ["results_json"], _srv_rate_classes);
  main.variable(observer("srv_distribution")).define("srv_distribution", ["getRateDistribution"], _srv_distribution);
  main.variable(observer("omega_rate_classes")).define("omega_rate_classes", ["_","results_json"], _omega_rate_classes);
  main.variable(observer("mh_rates")).define("mh_rates", ["_","results_json"], _mh_rates);
  main.variable(observer("test_omega")).define("test_omega", ["getRateDistribution"], _test_omega);
  main.variable(observer("test_pv")).define("test_pv", ["_","results_json"], _test_pv);
  main.variable(observer("distributionTable")).define("distributionTable", ["posteriorsPerBranchSite","pv","_","results_json","test_omega"], _distributionTable);
  main.variable(observer("getRateDistribution")).define("getRateDistribution", ["_","results_json"], _getRateDistribution);
  main.variable(observer("partition_sizes")).define("partition_sizes", ["_","results_json"], _partition_sizes);
  main.variable(observer("siteIndexPartitionCodon")).define("siteIndexPartitionCodon", ["_","results_json"], _siteIndexPartitionCodon);
  main.variable(observer("siteTableData")).define("siteTableData", ["_","profileBranchSites","results_json","siteIndexPartitionCodon","srv_distribution","distMean","d3","pv","html"], _siteTableData);
  main.variable(observer("sites_table")).define("sites_table", ["siteTableData"], _sites_table);
  main.variable(observer("profileBranchSites")).define("profileBranchSites", ["_","results_json","generateNodeLabels","tree_objects","subs_for_pair"], _profileBranchSites);
  main.variable(observer("posteriorsPerBranchSite")).define("posteriorsPerBranchSite", ["_","results_json","test_omega","generateNodeLabels","tree_objects","subs_for_pair"], _posteriorsPerBranchSite);
  main.variable(observer("characterPlot")).define("characterPlot", ["treeNodeOrdering","results_json"], _characterPlot);
  main.variable(observer("table3_data")).define("table3_data", ["_","profileBranchSites","which_branch","bsPositiveSelection"], _table3_data);
  main.variable(observer("bsPositiveSelection")).define("bsPositiveSelection", ["posteriorsPerBranchSite"], _bsPositiveSelection);
  main.variable(observer("path_diff")).define("path_diff", ["_","translate_ambiguous_codon"], _path_diff);
  main.variable(observer("subs_for_pair")).define("subs_for_pair", ["_","translate_ambiguous_codon","path_diff"], _subs_for_pair);
  main.variable(observer("generateNodeLabels")).define("generateNodeLabels", ["translate_ambiguous_codon","_"], _generateNodeLabels);
  main.variable(observer("treeNodeOrdering")).define("treeNodeOrdering", ["tree_objects","d3","results_json"], _treeNodeOrdering);
  main.variable(observer("distMean")).define("distMean", ["_"], _distMean);
  main.variable(observer("distVar")).define("distVar", ["distMean","_"], _distVar);
  main.variable(observer("er_step_size")).define("er_step_size", ["results_json"], _er_step_size);
  main.variable(observer("d3")).define("d3", ["require"], _d3);
  main.variable(observer("floatFmt")).define("floatFmt", ["d3"], _floatFmt);
  main.variable(observer("seqNames")).define("seqNames", _seqNames);
  main.variable(observer("dyn_range_cap")).define("dyn_range_cap", _dyn_range_cap);
  main.variable(observer("ERPlot")).define("ERPlot", ["d3","dyn_range_cap","pv","_"], _ERPlot);
  main.variable(observer("SRVPlot")).define("SRVPlot", ["_","dyn_range_cap"], _SRVPlot);
  main.variable(observer("BSPosteriorPlot")).define("BSPosteriorPlot", ["_","rate_table","treeNodeOrdering","profilable_branches","tested_branch_count","fig1_controls"], _BSPosteriorPlot);
  main.variable(observer("ERPosteriorPlot")).define("ERPosteriorPlot", ["_","rate_table","treeNodeOrdering","profilable_branches","tested_branch_count","fig1_controls"], _ERPosteriorPlot);
  main.variable(observer("_")).define("_", ["require"], __);
  main.variable(observer("tree_objects")).define("tree_objects", ["_","results_json","phylotree"], _tree_objects);
  main.variable(observer("totalTreeLength")).define("totalTreeLength", _totalTreeLength);
  main.variable(observer("subs_by_branch")).define("subs_by_branch", ["_","results_json"], _subs_by_branch);
  main.variable(observer("site_support_by_branch")).define("site_support_by_branch", ["_","results_json"], _site_support_by_branch);
  main.variable(observer("label_color_scale")).define("label_color_scale", ["d3"], _label_color_scale);
  main.variable(observer("display_tree")).define("display_tree", ["treeDim","_","results_json","branch_length","treeLabels","add_svg_defs","d3","color_branches","test_omega","test_pv","add_branch_label","subs_by_branch","mh_rates"], _display_tree);
  main.variable(observer("display_tree_handle_neighbors")).define("display_tree_handle_neighbors", ["generateNodeLabels","_"], _display_tree_handle_neighbors);
  main.variable(observer("display_tree_site")).define("display_tree_site", ["treeDim","_","results_json","branch_length","generateNodeLabels","treeLabels","add_svg_defs","display_tree_handle_neighbors","partition_sizes","d3","label_color_scale","color_branches","test_omega","mh_rates","add_branch_label"], _display_tree_site);
  main.variable(observer("add_branch_label")).define("add_branch_label", ["_","parse_svg","DOM"], _add_branch_label);
  main.variable(observer("add_svg_defs")).define("add_svg_defs", _add_svg_defs);
  main.variable(observer("treeViewOptions")).define("treeViewOptions", ["results_json","_"], _treeViewOptions);
  main.variable(observer("tree_color_options")).define("tree_color_options", ["results_json","_","mh_rates"], _tree_color_options);
  main.variable(observer("phylotree")).define("phylotree", ["require"], _phylotree);
  main.variable(observer("vegalite")).define("vegalite", ["require"], _vegalite);
  const child1 = runtime.module(define1);
  main.import("select", child1);
  main.import("text", child1);
  main.import("input", child1);
  main.import("autoSelect", child1);
  main.variable(observer("params")).define("params", ["URLSearchParams","location"], _params);
  const child2 = runtime.module(define2);
  main.import("legend", child2);
  const child3 = runtime.module(define3);
  main.import("localFileInput", child3);
  const child4 = runtime.module(define4);
  main.import("renderDiscreteDistribution", child4);
  main.import("renderNDiscreteDistributions", child4);
  main.import("renderTwoDiscreteDistributions", child4);
  const child5 = runtime.module(define5);
  main.import("translate_ambiguous_codon", child5);
  const child6 = runtime.module(define2);
  main.import("Legend", child6);
  main.import("Swatches", child6);
  const child7 = runtime.module(define6);
  main.import("cdsQuant", child7);
  const child8 = runtime.module(define7);
  main.import("multiAutoSelect", child8);
  main.variable(observer("pako")).define("pako", ["require"], _pako);
  main.variable(observer("parse_svg")).define("parse_svg", _parse_svg);
  main.variable(observer("bustedStyle")).define("bustedStyle", ["html"], _bustedStyle);
  main.variable(observer("simpleIcons")).define("simpleIcons", ["html"], _simpleIcons);
  return main;
}
